<template>
  <div class="confirmation">
    <div class="confirmation-wrap">
      <div class="confirmation-arrow">
        <BliIconSiArrowLeft
          class="confirmation-arrow_icon"
          @click="logOutUser"
        />
      </div>
      <div class="confirmation-image">
        <img
          src="@vue3/assets/images/registration-denied.svg"
          alt="icon"
        >
      </div>
    </div>
    <div class="confirmation-card">
      <div class="confirmation-card-body">
        <div class="title">
          {{ $t('login.REJECTED.title') }}
        </div>
        <div
          v-if="currentCompanyInfo.financeRegistrationRejectedReason"
          class="content"
        >
          <div class="title">
            {{ $t('login.REJECTED.finance') }}
          </div>
          <div class="reason">
            {{ currentCompanyInfo.financeRegistrationRejectedReason }}
          </div>
        </div>
        <div
          v-if="currentCompanyInfo.registrationRejectedReason"
          class="content"
        >
          <div class="title">
            {{ $t('login.REJECTED.legal') }}
          </div>
          <div class="reason">
            {{ currentCompanyInfo.registrationRejectedReason }}
          </div>
        </div>
        <div
          v-if="currentCompanyInfo.salesRegistrationRejectedReason"
          class="content"
        >
          <div class="title">
            {{ $t('login.REJECTED.sales') }}
          </div>
          <div class="reason">
            {{ currentCompanyInfo.salesRegistrationRejectedReason }}
          </div>
        </div>
      </div>
      <div class="continue-button">
        <BliButton
          full-width
          @click="handleAction"
        >
          {{ $t('login.REJECTED.buttonText') }}
        </BliButton>
      </div>
      <div class="confirmation-card-banner">
        <BliIconSiUspCustomerCare
          height="18px"
          width="18px"
          class="banner_icon"
        />
        <div class="confirmation-card-banner_content">
          {{ $t('login.REJECTED.helper') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script src="./index.js" />
<style lang="scss" scoped>
html:not([dark]) {
  @import '@blibli/blue-design-tokens/dist/tokens-default.scss';
  @import './index.scss';
}
html[dark] {
  @import '@blibli/blue-design-tokens/dist/tokens-dark.scss';
  @import './index.scss';
}
</style>
